import React from 'react';
interface StarRatingProps {
  className?: string;
}
export function StarRating({
  className = ''
}: StarRatingProps) {
  return <span className={`text-gold ${className}`} aria-label="5 out of 5 stars" data-id="element-197" data-mp="3fe917hwtgpdh">
      ★★★★★
    </span>;
}